import { useMemo } from 'react';

import { TrustedDeviceQuery } from '@dreryk/egabinet-security-frontend-api';

import {
   LazyLoadedDataConfigurationByCqrsQuery,
   useLazyLoadedDataConfigurationByCqrsQuery,
} from '@dreryk/drerykweb-main-frontend';
import { dateTimeMinuteFormatter } from '@dreryk/react-common';
import {
   createDynamicColumnsWidth,
   Padding,
   TableColumnConfiguration,
   ValueRendererProps,
} from '@dreryk/react-components';
import { Slot } from '@dreryk/watermelon';

import { mfaSettingsTranslationKeys } from '../../../../translations';

import { DeviceRemoveCell } from './cells/DeviceRemoveCell';
import { StyledOrdinalNumberCell } from './cells/OrdinalNumberCell.styled';
import { TrustedDevice } from './trustedDevices.types';

type TrustedDevicesTableColumnOptions = {
   onDeviceRemoveSuccess: VoidFunction;
};

export const useTrustedDevicesLazyLoadedDataConfigurationByCqrsQuery = (): LazyLoadedDataConfigurationByCqrsQuery<TrustedDevice> =>
   useLazyLoadedDataConfigurationByCqrsQuery(() => {
      const query = new TrustedDeviceQuery();
      query.name = Slot.empty();
      return query;
   });

export const useTrustedDevicesTableColumns = (
   options: TrustedDevicesTableColumnOptions
): TableColumnConfiguration<TrustedDevice>[] => {
   return useMemo(() => {
      const columnsWidth = createDynamicColumnsWidth({
         ordinalNumber: '38px',
         options: '25px',
         lastLoginDate: '210px',
         name: '100%',
      });

      return [
         {
            label: mfaSettingsTranslationKeys.trustedDeviceTable.ordinalNumber,
            accessor: 'id',

            renderer: (props: ValueRendererProps<TrustedDevice>): JSX.Element => (
               <StyledOrdinalNumberCell>
                  {props.index + 1}
                  {'.'}
               </StyledOrdinalNumberCell>
            ),
            width: columnsWidth.ordinalNumber,
            sortingDisabled: true,
         },
         {
            label: mfaSettingsTranslationKeys.trustedDeviceTable.deviceName,
            accessor: 'name',
            width: columnsWidth.name,
            sortingDisabled: true,
         },
         {
            label: mfaSettingsTranslationKeys.trustedDeviceTable.lastLoginDate,
            accessor: 'lastLoginDate',
            formatter: dateTimeMinuteFormatter,
            width: columnsWidth.lastLoginDate,
            sortingDisabled: true,
         },
         {
            accessor: (bean) => bean.id,
            name: 'options',

            renderer: (props: ValueRendererProps<TrustedDevice>): JSX.Element => (
               <DeviceRemoveCell
                  deviceId={props.bean.id}
                  deviceName={props.bean.name}
                  onRemoveSuccess={options.onDeviceRemoveSuccess}
               />
            ),
            width: columnsWidth.options,
            sortingDisabled: true,
            padding: Padding.NONE,
         },
      ];
   }, [options]);
};
